import React from "react";

import ContentLoader from 'react-content-loader';

function LoadingSquare() {
  return (<>
    <ContentLoader
      speed={3}
      width="100"
      height="100"
      viewBox="0 0 100 100"
      backgroundColor="#696969"
      foregroundColor="#363636"
      style={{ width: "100%", height: "200px" }}
    >
      <rect x="0" y="0" rx="2" ry="2" width="100" height="100" />
    </ContentLoader>
  </>);
}

export default LoadingSquare;
